import VVSTable from "components/form-control/VVSTable";
import React from "react";
import { Container } from "reactstrap";

export default function TrainingCategory() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <VVSTable title="Training Category" name="TrainingCategory" />
        </Container>
      </div>
    </React.Fragment>
  );
}
